import { render, staticRenderFns } from "./AccountSuccessMessage.vue?vue&type=template&id=05a02299&"
import script from "./AccountSuccessMessage.vue?vue&type=script&lang=js&"
export * from "./AccountSuccessMessage.vue?vue&type=script&lang=js&"
import style0 from "./AccountSuccessMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports